import React from "react";
import tw from "twin.macro";
import styled, { css } from "styled-components/macro";
import WordSpacedText from "../components/WordSpacedText.js";
import { PrimaryButton } from "components/misc/Buttons";

// Container & layout
const Container = tw.div`relative bg-white py-20 lg:py-24`;
const Content = tw.div`max-w-screen-xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8  md:px-12 items-start`;

// Map panel
const MapCard = styled.div`
  ${tw`relative rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-white`}
  min-height: 24rem;
  iframe {
    ${tw`w-full h-full`}
    border: 0;
  }
`;

// Info panel styled as a card
const InfoCard = styled.div`
  ${tw`rounded-xl shadow-lg border border-gray-200 bg-white p-8`}
`;

const Heading = tw.h2`text-2xl md:text-3xl font-bold text-gray-900 mb-6`;
const Item = styled.p`
  ${tw`text-sm md:text-lg text-gray-700 leading-relaxed`}
  ${(props) =>
    props.emphasis &&
    css`
      ${tw`text-primary-500 font-semibold`}
    `}
`;

const Link = tw.a`text-primary-500 hover:text-primary-700 underline`;

export default function MapSection() {
  const mapsLink =
    "https://www.google.com/maps/place/JAMIA+MUHAMMADIA+ARABIC+COLLEGE/@14.7038356,76.8492867,1350m/data=!3m1!1e3!4m6!3m5!1s0x3bb735a60a87a5c5:0x56da9e08c4acfbb3!8m2!3d14.7072657!4d76.8592691!16s%2Fg%2F11c45np8pv";
  const mapsEmbed =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5879.181162572243!2d76.84928670869138!3d14.703835626943384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb735a60a87a5c5%3A0x56da9e08c4acfbb3!2sJAMIA%20MUHAMMADIA%20ARABIC%20COLLEGE!5e1!3m2!1sen!2sin!4v1746176702545!5m2!1sen!2sin";

  return (
    <Container>
      <Content>
        {/* Info card left */}
        <InfoCard>
          <WordSpacedText>
            <Heading>Contact Details</Heading>
          </WordSpacedText>
          <Item>
            📍{" "}
            <WordSpacedText>
              RAYADURG - 515 865, Anantapur Dist. (A.P.), India.
            </WordSpacedText>
          </Item>
          <div css={tw`space-y-3 mt-4`}>
            <Item>
              🌐 Website:{" "}
              <Link
                href="https://jmardg.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.jmardg.com
              </Link>
            </Item>
            <Item>
              ✉️ Email:{" "}
              <Link href="mailto:jamiamohammadia1926@gmail.com">
                jamiamohammadia1926@gmail.com
              </Link>
            </Item>
            <Item>
              🔵 Facebook:{" "}
              <Link
                href="https://www.facebook.com/yourfacebookpage"
                target="_blank"
                rel="noopener noreferrer"
              >
                Jamia Mohammadia Arabia Rayadurg
              </Link>
            </Item>
            <Item>
              📞 Phone:
              <Link href="tel:+919347967042">9347967042</Link> —{" "}
              <Link href="tel:+919347967042">9347967042</Link>
            </Item>
          </div>
          <div css={tw`mt-6`}>
            <PrimaryButton
              as="a"
              href={mapsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Maps
            </PrimaryButton>
          </div>
        </InfoCard>

        {/* Map card right */}
        <MapCard>
          <iframe
            src={mapsEmbed}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Map showing Jamia Muhammadiya Arabic College"
          />
        </MapCard>
      </Content>
    </Container>
  );
}
